import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import { FormattedMessage  } from 'react-intl';
import '../App.css';

class ReportDescription extends Component {
  
    render() {
      return (
          <div>
            <Typography.Text style={{position: "relative", bottom: "90%"}} type="secondary"><FormattedMessage id={this.props.description}/></Typography.Text>
          </div>
    );
  }
}

const propTypes = {
    description: PropTypes.string.isRequired,
  };
  ReportDescription.propTypes = propTypes;
  
  export default ReportDescription;